import React, { Component } from 'react';

const RequiredLabel = (props) => {
    return (
      <label {...props}>{props.children}<span className="text-danger required" style={{marginLeft:'20px'}}>*</span></label>
    );
  };
  
  export default RequiredLabel;
  